var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inline-block"},[_c('i',_vm._g({staticClass:"not-italic",class:_vm.iconClass,attrs:{"title":_vm.title,"aria-hidden":"true"}},_vm.listeners)),_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.screenReaderText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }